import React from 'react';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';

const MoreButton = ({onClick, text}) => 
<Button
    block
    onClick={onClick}
>
    {text || "More "}<i className="fa fa-angle-down" />
</Button>;

MoreButton.propType = {
    onClick: PropTypes.func.isRequired
};

export default MoreButton;


// WEBPACK FOOTER //
// ./src/Components/search/components/MoreButton.jsx